export enum LoadType {
  raster = <any>'raster',
  cached = <any>'cached'
}
